<template>
  <v-card class="charge-record-chart rounded-xl" variant="flat" title="充放电记录" :loading="loading">
    <v-card-text>      
      <v-form class="d-flex align-center">        
        <div style="width: 200px;">
          <v-date-input label="请选择日期" v-model="date" density="compact"  hide-details variant="outlined"></v-date-input>
        </div>
        <v-btn class="ml-2" @click="handleSearch" variant="flat" prepend-icon="mdi-magnify" color="#3E6AFC" rounded="lg">查询</v-btn>              
      </v-form>


      <v-divider class="my-4"></v-divider>

      <div class="record-chart">
        <div class="record-elink-srrategy">
          <div class="record-title">
            <div>运行策略</div>
            <div>1#eLink</div>
          </div>
          <div class="srrategy-items">
            <div class="srrategy-item charge">充电 90kWh</div>
            <div class="srrategy-item discharge">放电 90kWh</div>
            <div class="srrategy-item charge">充电 90kWh</div>
            <div class="srrategy-item idle">静置 0kWh</div>
          </div>
        </div>
      </div>


    </v-card-text>
  </v-card>
</template>




<script setup>
import { reactive, ref } from 'vue';
import { getStationRunningRecord } from '@/api/chargeRecord';
import { useStationContext } from '@/views/station-monitor/detail/composables/useStationContext'
import dayjs from 'dayjs';
const date = ref(dayjs().format('YYYY-MM-DD'));
const loading = ref(false)

const { stationId, stationName, stationBaseData } = useStationContext()


const data = reactive({
  chargeAndDischargeRecord: [],
  strategy: [],  
})


async function updateChartData() {
  loading.value = true
  try {
    const res = await getStationRunningRecord({
      stationId: stationId.value,
      date: dayjs(date.value).format('YYYY-MM-DD'),
      // eLinkUuid: eLinkUuid.value,
      // eBlockUuid: eBlockUuid.value
    })
    console.log(res);

    data.chargeAndDischargeRecord = res.data.chargeAndDischargeRecord || []
    data.strategy = res.data.strategy || []

  } catch (error) {
    console.error(error);
    return []
  } finally {
    loading.value = false
  }
}

updateChartData()


const handleSearch = () => {
  console.log('查询', date.value);

  updateChartData()
}



</script>




<style scoped lang="scss">
.charge-record-chart {
  height: calc(100vh - var(--header-height) - 150px);
}


// 
.record-elink-srrategy {
  border: 1px solid red;
  display: flex;
}
.srrategy-items {
  border: 1px solid blue;
  flex: 1;
  position: relative;
  display: flex;
}
.charge {
  background-color: #B6E633;
}
.discharge {
  background-color: #FEAEC9;
}
.idle {
  background-color: #999999;
}
.srrategy-item {
  // position: absolute;
  // top: 0;
  // bottom: 0;

  // width: 50%;
  flex: 1;
  border: 1px solid green;
}
</style>
